import React from 'react';
import { FaFacebook } from 'react-icons/fa';
import constitutionPdf from '../data/constitution.pdf';
import directorsPdf from '../data/directors.pdf';
import memberShipApplication from '../data/membership_application.docx';
import memberShipProcedures from '../data/membership_procedures.pdf';

const Footer: React.FC = () => {
  const docLinks = [
    { label: '会則', href: constitutionPdf },
    { label: '役員名簿', href: directorsPdf },
    { label: '入会手続きについて', href: memberShipProcedures },
    { label: '入会申込書', href: memberShipApplication },
  ];

  return (
    <footer className="bg-[#1a4a2e] text-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12 mb-10 sm:mb-14">

          {/* ロゴ + 住所 */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/ebc-portal-icon.png" alt="Logo" className="h-8 w-8 object-contain" />
              <span className="font-bold text-base sm:text-lg">民族文化生物学研究会</span>
            </div>
            <p className="text-white/60 text-xs sm:text-sm leading-relaxed">
              〒543-0062<br />
              大阪府大阪市天王寺区逢坂１丁目１-1-16<br />
              逢坂ビル 603<br />
              株式会社農業サポートセンター（担当: 高橋）
            </p>
          </div>

          {/* リンク */}
          <div>
            <h3 className="font-bold mb-4 text-sm sm:text-base">ドキュメント</h3>
            <nav className="space-y-2">
              {docLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-white/60 hover:text-white transition-colors text-xs sm:text-sm"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* SNS */}
          <div>
            <h3 className="font-bold mb-4 text-sm sm:text-base">SNS</h3>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/groups/1766621973822947/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                aria-label="Facebook"
              >
                <FaFacebook className="text-lg" />
              </a>
            </div>
          </div>
        </div>

        {/* コピーライト */}
        <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-2 text-white/40 text-xs sm:text-sm">
          <p>© 2024–2026 Society for Ethno-Cultural Biology. All rights reserved.</p>
          <p>Developed by Tanesaka</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
